import * as React from 'react';

const PaypalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32}>
    <g clipPath="url(#a)">
      <path fill="#fff" d="M0 0h32v32H0z" />
      <path
        fill="#fff"
        d="M27.2 0H4.8A4.8 4.8 0 0 0 0 4.8v22.4A4.8 4.8 0 0 0 4.8 32h22.4a4.8 4.8 0 0 0 4.8-4.8V4.8A4.8 4.8 0 0 0 27.2 0Z"
      />
      <path
        fill="#002C8A"
        d="m23.564 11.55-12.27 13.387h-4.5c-.312 0-.562-.312-.5-.625l3-19a.876.876 0 0 1 .876-.75h7.625c5.25.188 6.687 2.875 5.75 7l.018-.012Z"
      />
      <path
        fill="#009BE1"
        d="M23.764 10.313c1.875 1 2.312 2.874 1.687 5.374-.813 3.688-3.25 5.25-6.813 5.313l-1 .063c-.375 0-.625.25-.687.625l-.813 4.937a.876.876 0 0 1-.875.75h-3.75c-.312 0-.562-.313-.5-.625l1.376-8.938c.062-.312 11.375-7.5 11.375-7.5Z"
      />
      <path
        fill="#001F6B"
        d="m12.313 18.25 1.25-7.938a.875.875 0 0 1 .812-.687h6c1.438 0 2.5.25 3.375.688-.313 2.75-1.625 7.187-8 7.312H13c-.313 0-.625.25-.688.625Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default PaypalIcon;
